import React from 'react';
import './CheckBox.css';

class CheckBox extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            isChecked: false, 
            children: props.item.children,
            value: this.props.item.option
        };
        this.onChecked = this.onChecked.bind(this);
        this.onChanged = this.onChanged.bind(this);
    }

    onChecked(){
        this.props.onToggle(this.props.index);
    }

    onChanged(checked){
        this.setState({
            isChecked: checked
        });
    }

    render() {
        return (
            <div>
                <div className="CheckBox">
                    <input 
                        className="CheckBox-input" 
                        id={"id" + this.props.item.option} 
                        name={this.props.name} 
                        type="radio" 
                        value={this.props.item.option}
                        onChange={this.onChecked}
                    />
                    <label className="CheckBox-label" htmlFor={"id" + this.props.item.option}>{this.props.item.label}</label>
                </div>
                {this.state.isChecked && this.state.children ? this.state.children : null}

            </div>
        );
    }
}

export default CheckBox;